import { render, staticRenderFns } from "./onlyHeader.vue?vue&type=template&id=393ebd8a&scoped=true&"
import script from "./onlyHeader.vue?vue&type=script&lang=js&"
export * from "./onlyHeader.vue?vue&type=script&lang=js&"
import style0 from "./onlyHeader.vue?vue&type=style&index=0&id=393ebd8a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393ebd8a",
  null
  
)

export default component.exports